import styles from "./styles.module.scss";
import primaryComponents from "../../../primaryComponents";
import { ArrowRight } from "../../../../assets/svgIcons";
import { useCloneSuggestedCampaign } from "../../../../hooks/api/mutations/useMarketing";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import { useState } from "react";
import secondaryComponents from "../..";

export const SmsAutomatedTable = ({
  automatedCampaigns = [],
  metaDetails = {},
  gotoPage = () => {},
}) => {
  const navigate = useNavigate();
  const [currentCloning, setCurrentCloning] = useState(null);
  const { mutate: cloneCampaign, isLoading } = useCloneSuggestedCampaign();

  const handleCloneCampaign = (id) => {
    setCurrentCloning(id);
    cloneCampaign(
      { id },
      {
        onSuccess: (res) => {
          navigate(
            pathConstants.MARKETING_SMS_CAMPAIGNS_CONTENT({
              id: res?.data?.data?.id,
            }),
          );
        },
        onSettled: () => {
          setCurrentCloning(null);
        },
      },
    );
  };

  return (
    <>
      <section className={styles.smsAutomatedTable}>
        {automatedCampaigns?.map((campaign) => {
          return (
            <article
              className={styles.smsAutomatedTable__card}
              key={campaign?.id}
            >
              <div className="d-flex justify-content-between">
                <div>
                  <h5>{campaign?.title}</h5>
                  <p>
                    {campaign?.description}
                    {/* <span className="dark--text ml-3">
                    ( <UserGroupIcon />{" "}
                    {campaign?.audience?.customer_count || 0})
                  </span> */}
                  </p>
                </div>

                {/* <div className="text-right">
                  <p className="small-text-size">Total Credit Cost</p>
                  <h5 className="purple--text">
                    {campaign?.total_cost}{" "}
                    <span className="gray--text font-weight-normal smallest-text-size">
                      credit
                    </span>
                  </h5>
                </div> */}
              </div>

              <div className={styles.content}>
                <div className={styles.content__message}>
                  <p>{campaign?.message_body}</p>
                </div>

                <primaryComponents.Button
                  classNames={"btn btn--primary ml-auto"}
                  style={{ width: "200px" }}
                  isDisabled={isLoading && currentCloning === campaign?.id}
                  isLoading={isLoading && currentCloning === campaign?.id}
                  onClick={() => handleCloneCampaign(campaign?.id)}
                >
                  Review & Send <ArrowRight className="ml-1" />
                </primaryComponents.Button>
              </div>
            </article>
          );
        })}
      </section>

      {/* pagination */}
      {automatedCampaigns?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}
    </>
  );
};
